/** A robot page's tabs. Its own module, free of imports, because the route reads it to parse
 * the address eagerly, before the page's code is loaded. */
export const ROBOT_TABS = ["overview", "operate"] as const;
export type RobotTab = (typeof ROBOT_TABS)[number];
